import * as EmailValidator from 'email-validator'

export const IsEmailValid = (email: string) => EmailValidator.validate(email)
